<template>
  <AppSection
    id="nav-credentials"
    type="section"
    :title="$getConst.pages.nav_credentials.nav_credentials_page_title"
    :is-section-loading="isLoading"
    >

    <b-row>

      <b-col sm="6">
        <b-form-group  id="nav-endpoint" :label="$t($getConst.pages.nav_credentials.nav_end_point_label) + ' *'" label-for="nav-endpoint-input">
          <b-form-input
            id="nav-endpoint-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.navDataToEdit.nav_endpoint.$model"
            :class="{ 'is-invalid': $v.navDataToEdit.nav_endpoint.$error }"
            :placeholder="$t($getConst.pages.nav_credentials.nav_end_point_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback  :errors="$v.navDataToEdit.nav_endpoint">
          </AppFormFeedback>
        </b-form-group>
      </b-col>


      <b-col sm="6">
        <b-form-group  id="nav-shared-key" :label="$t($getConst.pages.nav_credentials.nav_shared_key_label) + ' *'" label-for="nav-shared-key-input">
          <b-form-input
            id="nav-shared-key-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.navDataToEdit.nav_sharedKey.$model"
            :class="{ 'is-invalid': $v.navDataToEdit.nav_sharedKey.$error }"
            :placeholder="$t($getConst.pages.nav_credentials.nav_shared_key_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.navDataToEdit.nav_sharedKey"/>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group  id="nav-username" :label="$t($getConst.pages.nav_credentials.nav_username_label) + ' *'" label-for="nav-username-input">
          <b-form-input
            id="nav-username-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.navDataToEdit.nav_username.$model"
            :class="{ 'is-invalid': $v.navDataToEdit.nav_username.$error }"
            :placeholder="$t($getConst.pages.nav_credentials.nav_username_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.navDataToEdit.nav_username"/>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group  id="nav-password-label" :label="$t($getConst.pages.nav_credentials.nav_password_label) + ' *'" label-for="nav-password"
        >
        </b-form-group>
        <b-input-group-append is-text id="toggle-hidden-password" class="toggle-icon">
          <a id="display-password-button" @click="onDisplayPassword">
            <i :class="this.passwordHidden === true ? this.$getConst.icons.key : this.$getConst.icons.keyOpen " aria-hidden="true"></i>
          </a>
        </b-input-group-append>

        <b-form-group  id="nav-password" class="password-right"
                       :class="this.passwordHidden === true ?  'passwordDisplayed': true"
        >
          <b-input-group size="lg">
            <b-form-input
              id="nav-password-input"
              :disabled="hasWritePermission"
              :type="passwordInputType"
              v-model.trim="$v.navDataToEdit.nav_password.$model"
              :class="{ 'is-invalid': $v.navDataToEdit.nav_password.$error }"
              :placeholder="$t($getConst.pages.nav_credentials.nav_password_placeholder) + ' *'"
              size="lg"
              required
            ></b-form-input>
            <b-input-group-append is-text id="toggle-password">
              <a id="show-password-button" @click="onShowPassword">
                <i :class="this.passwordInputType === 'password' ? this.$getConst.icons.eyeSlash : this.$getConst.icons.eye" aria-hidden="true"></i>
              </a>
            </b-input-group-append>
          </b-input-group>
          <AppFormFeedback :errors="$v.navDataToEdit.nav_password"/>
        </b-form-group>
      </b-col>

    </b-row>

    <AppConfirmButtons
      v-if="!hasWritePermission"
      :second-button="hasAnyOfPermissions(
        [
          this.$getConst.permissions.readScope,
          this.$getConst.permissions.readScopeNavCredentials,
          this.$getConst.permissions.writeScope,
          this.$getConst.permissions.writeScopeNavCredentials,
        ]
      )"
      :second-button-text="this.$getConst.pages.connectivity_test.nav_test"
      :second-button-disabled="isTesting"
      :is-disabled="$v.navDataToEdit.$invalid"
      :is-loading="isLoading"
      @onSecondSubmit="testNavCredentials"
      @onSubmit="onSubmit"
      @onCancel="onCancel"
    />
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import {required, url} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import {getScopeNavCredentials, updateScopeNavCredentials,testNavCredentials} from "../../../../api/scopes.api";

  const matchUrl=(value) =>
   value ?value.split(":")['0'] === "http" ||  value.split(":")['0'] === "https":true;

  export default {
    name: "index",
    components: {AppConfirmButtons, AppFormFeedback, AppSection},
    props: {
      scope_id: null
    },
  data() {
      return {
        navData: null,
        isLoading: false,
        isTesting: false,
        navDataToEdit: {
          nav_endpoint: null,
          nav_sharedKey: null,
          nav_password: null,
          nav_username: null
        },
        passwordInputType: "password",
        passwordHidden: true,
        hasWritePermission: !this.hasAnyOfPermissions(
          [this.$getConst.permissions.writeScopeNavCredentials, this.$getConst.permissions.writeScope]
        ),
        snotifyConfig: {
          timeout: 5000,
          titleMaxLength: 40,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
        }
      }
    },
    validations: {
      navDataToEdit: {
        nav_endpoint: {required, matchUrl},
        nav_sharedKey: {required},
        nav_password: {},
        nav_username: {required},

      }
    },
    methods: {
      getNavData() {
        this.isLoading = true;
        getScopeNavCredentials(this.scope_id).then(
          (response) => {
            this.navData = Object.assign({}, response.data);
            this.navDataToEdit = response.data;
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      onSubmit() {

        this.isLoading = true;
        updateScopeNavCredentials(this.scope_id, this.navDataToEdit).then(
          (response) => {
            this.navData = Object.assign({}, response.data);
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          },
          (error) => {
            let msg = error.response.data.error;

            if (error.response.data.error === 'B17_invalid_NAV_credentials') {
              msg = this.$t(this.$getConst.pages.alerts.invalid_NAV_credentials);
            } else if (error.response.data.error === 'B199_no_response') {
              msg = this.$t(this.$getConst.pages.alerts.nav_endpoint_not_accessible);
            }

            this.$snotify.error(msg, this.$t(this.$getConst.pages.alerts.error));

            this.isLoading = false;
          }
        )
      },
      testNavCredentials() {
        this.isTesting = true;
        this.$snotify.async(
          this.$t(this.$getConst.pages.connectivity_test.nav_request_sending),
          this.$t(this.$getConst.pages.alerts.please_wait),
          () => new Promise((resolve, reject) => {
            testNavCredentials(this.scope_id, this.navDataToEdit).then(
              () => {
                this.isTesting = false;
                resolve({
                  title: this.$t(this.$getConst.pages.alerts.success),
                  body: this.$t(this.$getConst.pages.connectivity_test.nav_success_message),
                  config: this.snotifyConfig,
                })
              },
              (error) => {
                this.isTesting = false;

                let msg = error.response.data.error;

                if (error.response.data.error === 'B17_invalid_NAV_credentials') {
                  msg =  this.$t(this.$getConst.pages.alerts.invalid_NAV_credentials);
                } else if (error.response.data.error === 'B199_no_response') {
                  msg = this.$t(this.$getConst.pages.alerts.nav_endpoint_not_accessible);
                }

                reject({
                  title: this.$t(this.$getConst.pages.alerts.error),
                  body: msg,
                  config: this.snotifyConfig
                })
              }
            )
          })
        )
      },
      onCancel() {
        this.navDataToEdit = Object.assign({}, this.navData);
      },
      onShowPassword() {
        if (this.passwordInputType === "password") {
          this.passwordInputType = "text";
        } else {
          this.passwordInputType = "password";
        }
      },
      onDisplayPassword() {
        this.passwordHidden = !this.passwordHidden,
          this.isActive = !this.isActive;

      },

    },
    created() {
      this.getNavData();
    }
  }
</script>

<style scoped>
  #nav-password-input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  #toggle-password a, #toggle-hidden-password a{
    cursor: pointer;
  }
  #toggle-password {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }
  .passwordDisplayed{
    visibility: hidden !important;

  }
  #toggle-hidden-password {
    position: relative;
    padding-right: 16px;
    float: left;
  }
  #nav-password{
    margin-bottom: 0.5rem;
  }
  .password-right{
    float: right;
    position: relative;
    width: 80%;
  }

  .toggle-icon .input-group-text{
    padding: 0.64rem 1.4rem 0.65rem !important;
  }
  @media screen and (max-width: 880px) {

    .password-right {
      width: 70%;
    }
  }
  @media screen and (max-width: 295px) {

    .password-right{
      float: left;
      width: 98%;
      margin-top: 5%;
    }
  }
</style>
